module.exports = __webpack_public_path__ + "fonts/61c477f8-fef9-4faa-a464-e5b4096672c4.11a9c496.ttf";